import React, { useEffect, useState } from "react";
import { Formik, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import * as bannerService from "../../../services/banner.services";
import Breadcrums from "../../../common/breadcrumbs";
// import CustomCkeditor from "../../../common/customeditor";
import { showFilterlist, SWAL_SETTINGS, URL_REGEX } from "../../../../../utils/Constants";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import * as Yup from "yup";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";
import CustomError from "../../../../../utils/customError";

const BannerAdd = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [initialValues, setInitialValues] = useState({
    title: "",
    link: "",
    // richtext: "",
    // richtext_de: "",
    files: "",
    status : ""
  });

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_banners"), url: "/admin/cms/banner/list/1" },
    { title: t("link_add"), url: "" },
  ];

  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state.title : "",
      link: state && state?.link ? state.link : "",
      files: "",
      status: state && state?.status ? state.status : ""
    });
    setDataLoaded(true);
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string()
  .required(t("label_title_error"))
  .test("no-spaces", t("label_title_error"), (value) => value && value.trim().length > 0)
  .test("max-trimmed-length", t("max_characters_error", { count: 80 }), (value) => {
    return value?.trim().length <= 80;
  }),
    files: Yup.mixed()
      .required(t("label_image_error"))
      .test("fileType", t("label_image_format_error"), (value) => {
        if (!value) return false;
        const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
        return supportedFormats.includes(value.type);
      }),
     status: Yup.string()
  .required(t("label_status_required")) 
  .test("no-spaces", t("label_status_required"), (value) => value && value.trim().length > 0),

      link: Yup.string()
      .transform(value => (typeof value === "string" ? value.trim() : value))
      .required(t("label_link_error"))
      .matches(URL_REGEX, t("label_link_invalid"))
      .max(250, t("max_url_length_error")),
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("link", values.link.trim());
            formData.append("status", values.status);
            formData.append("image", values.files);
            bannerService
              .Add(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  globalLoader(false);
                  setTimeout(() => {
                    resetForm({ values: "" });
                    navigate(`/admin/cms/banner/list/1`);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  globalLoader(false);
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("link_add")} {t("btn_banner")}</h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("label_Banner_title")}: <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="title"
                            id="title"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage name={"title"} />
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="link" className="text-left d-flex">
                            {t("label_link")}:
                          </label>
                          <input
                            name="link"
                            id="link"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.link}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.link && touched.link && errors.link}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >


                              {showFilterlist.map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>
                                   {t(value.name)}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                          {errors.status && touched.status && errors.status}
                    </span>
                        </div>

                     
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="files" className="text-left d-flex">
                            {t("label_image")}:<span className="requirestar">*</span>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Recommended Size (1920x887)</Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            className="form-control imgInput"
                            id="files"
                            name="files"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              setFieldValue(
                                "files",
                                event.currentTarget.files[0] || ""
                              );
                              event.currentTarget.files.length === 1
                                ? setPreviewImage(
                                  URL.createObjectURL(
                                    event.currentTarget.files[0]
                                  )
                                )
                                : setPreviewImage("");
                            }}
                          />
                          <span
                            className="text-danger d-flex text-left"
                            id="errortext"
                          >
                            {errors.files && touched.files && errors.files}
                          </span>
                        </div>
                     
                        {previewimage ? (
                          <ul className="question-image-preview questions-ul">
                            <li className="pr_img_box">
                              <img
                                src={previewimage}
                                style={{ height: "100px" }}
                                alt={t("banner-image")}
                              />
                              <div className="img_options">
                                <button type="button" className="text-danger"
                                  onClick={() => {
                                    // console.log(previewResImage , previewimage)
                                    setPreviewImage("");
                                    setFieldValue("files", "");
                                    document.getElementById("files").value = ""
                                  }}>
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            disabled={submitted ? true : null}
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default BannerAdd;
